import { tagged } from "@mirage/service-logging";
import { useEffect, useState } from "react";
import { observeConversationList } from "../";

import type { ConversationMetadata } from "@mirage/service-conversation/types";

export type ConversationListState =
  | {
      type: "loading";
    }
  | {
      type: "loaded";
      conversationMetadatas: ConversationMetadata[];
    }
  | {
      type: "error";
      error: string;
    };

const logger = tagged("useConversationsList");

/**
 * Hook to fetch and manage the list of user conversations.
 * @returns The current state of the conversations list and loading state
 */
export function useConversationsList(): ConversationListState {
  const [conversationListState, setConversationListState] =
    useState<ConversationListState>({
      type: "loading",
    });

  useEffect(() => {
    const subscription = observeConversationList().subscribe(
      (result) => {
        setConversationListState({
          type: "loaded",
          conversationMetadatas: result,
        });
      },
      (err) => {
        logger.error("Error in conversations observer:", err);
        setConversationListState({
          type: "error",
          error: err.message,
        });
      },
    );
    return () => subscription.unsubscribe();
  }, []);

  return conversationListState;
}

export default useConversationsList;
